module.exports = __webpack_public_path__ + "media/native-apps/varnamo-36373b4d.webp";